// Staff bake-off switch (#199): flips the search backend (BigQuery ↔ Algolia)
// live, threaded into suggest/products via the api client. Lives in the Header.
// Deleting this file + its Header usage dismisses the toggle and restores #198.
import { type SearchBackendName, setSearchBackend, useSearchBackend } from '../lib/searchBackend';

const OPTIONS: Array<{ value: SearchBackendName; label: string }> = [
  { value: 'gcp', label: 'BigQuery' },
  { value: 'algolia', label: 'Algolia' },
];

export function SearchBackendToggle() {
  const backend = useSearchBackend();
  return (
    <div
      role="radiogroup"
      aria-label="Motor de búsqueda"
      className="inline-flex rounded-md border border-border-default overflow-hidden text-xs"
    >
      {OPTIONS.map((o) => {
        const selected = backend === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`px-2.5 py-1 ${
              selected
                ? 'bg-bg-subtle text-text-primary font-medium'
                : 'text-text-secondary hover:text-text-primary'
            }`}
            onClick={() => setSearchBackend(o.value)}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
